module.exports = __webpack_public_path__ + "static/img/wyapp.a51d099.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CCT001/wyapp.png
// module id = zCMX
// module chunks = 1